

import { useEffect, useState } from "react";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";

export const ScrollArrow = () => {
    const [isAtTop, setIsAtTop] = useState(true);
    const [isAtBottom, setIsAtBottom] = useState(false);
  
    useEffect(() => {
      const handleScroll = () => {
        const scrollTop = window.scrollY;
        const windowHeight = window.innerHeight;
        const docHeight = document.body.scrollHeight;
  
        setIsAtTop(scrollTop < 100);
        setIsAtBottom(scrollTop + windowHeight >= docHeight - 100);
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
  
    const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
    const scrollToNext = () =>
      window.scrollBy({ top: window.innerHeight, behavior: "smooth" });
  
    return (
      <div className="fixed bottom-6 right-6 z-50">
        {!isAtBottom && (
          <button
            onClick={scrollToNext}
            className="bg-amber-800 hover:bg-amber-700 text-white p-3 rounded-full shadow-lg transition"
          >
            <FaArrowDown />
          </button>
        )}
        {isAtBottom && (
          <button
            onClick={scrollToTop}
            className="bg-amber-800 hover:bg-amber-700 text-white p-3 rounded-full shadow-lg transition"
          >
            <FaArrowUp />
          </button>
        )}
      </div>
    );
  };